import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    error: [],
    loading: false,
    data: false
};

const slice = createSlice({
    name: "courses",
    initialState,
    reducers: {
        CoursesRequest: (courses) => {
            courses.loading = true;
            courses.error = false;
        },
        CoursesClear: (courses) => {
            courses.error = false;
            courses.loading = false;
        },
        CoursesSuccess: (courses, action) => {
            courses.loading = false;
            courses.error = false;
            courses.data = action.payload;
        },
        CoursesError: (courses, action) => {
            courses.loading = false;
            courses.error = action.payload;
        },
        UpdateCoursesList: (courses, action) => {
            if (courses.data && courses.data.results) {
                courses.data.results = action.payload.results;
                courses.data.pagination = action.payload.pagination;
            }
        }
    }
});

export const { CoursesClear, CoursesRequest, CoursesSuccess, CoursesError, UpdateCoursesList } = slice.actions;
export default slice.reducer;
